module.exports = __webpack_public_path__ + "static/retmes-lp-erp-d0b5c682a60a462ee69caecffda9053d.png";